import React from 'react';

import FormHeader from 'prequalificationV2/components/FormHeader';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';

const SentResetPasswordLink = () => {
  const { email } = useAppSelector((state) => state.account);

  return (
    <FormHeader
      title={`We have emailed a password reset link to ${email} if it exists in our system.`}
      percent={ProgressBarStatus.Failed}
    />
  );
};

export default SentResetPasswordLink;
